import { render } from "./FacebookIcon.vue?vue&type=template&id=51a282f1&scoped=true"
import script from "./FacebookIcon.vue?vue&type=script&lang=js"
export * from "./FacebookIcon.vue?vue&type=script&lang=js"

import "./FacebookIcon.vue?vue&type=style&index=0&id=51a282f1&scoped=true&lang=css"

import exportComponent from "/Users/muftaua/Documents/dev/CCD-Stuff/web-ccd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a282f1"]])

export default __exports__